//todo: implement date forrmating based on the field setting in DateField

class DialogMixin {

    deleteDialog(title, body, callback) {
        this._dialog(title,body,{
            dialogClass: 'delete-dialog people-js-react-crm-record-delete',
            buttons: {
                Delete: function () {
                    if (callback) {
                        callback();
                    }
                    $(this).dialog("close");
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            },
        });

    };

    confirmUnpublishDialog(title, body, unpublishCallback, newVersionCallback) {

        this._dialog(title,body,{
            dialogClass: 'confirm-popup',
            buttons: {
                Unpublish: function () {
                    $(this).dialog("close");
                    unpublishCallback();
                },
                'Create New Version': function () {
                    $(this).dialog("close");
                    newVersionCallback();
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            },
        });
    };

    userUnpublishConfirmation(title, body, buttonText, confirmCallback) {
        let buttons = {
            Cancel: function () {
                $(this).dialog("close");
            },
        };
        buttons[buttonText] = function () {
            $(this).dialog("close");
            confirmCallback();
        };

        this._dialog(title, body, {
            dialogClass: 'confirm-popup',
            buttons: buttons,
            minWidth: 650,
        });
    };

    infoDialog(title, body, afterClose) {
        this._dialog(title,body,{
            dialogClass: 'success-dialog',
            buttons: {
                Ok: function () {
                    $(this).dialog("close");
                    if (afterClose) {
                        afterClose();
                    }
                }
            }
        });
    };

    confirmDialog(title, body, afterClose) {
        this._dialog(title,body,{
            dialogClass: 'success-dialog',
            buttons: {
                Yes: function () {
                    $(this).dialog("close");
                    if (afterClose) {
                        afterClose();
                    }
                },
                No: function () {
                    $(this).dialog("close");
                },
            }
        });
    };

    errorDialog(title, body) {
        this._dialog(title,body,{
            dialogClass: 'error-dialog',
        });
    };

    _dialog(title,body,options){
        let popupHolder = $('body');
        let popupId = "popup-alert-container-" + Math.random().toString(36).substring(7);
        if (body instanceof Array) {
            body = body.join('<br />');
        }
        popupHolder.append('<div id="' + popupId + '">' + body + '</div>');

        let defaultOptions = {
            title: title,
            resizable: false,
            minWidth: 450,
            minHeight: 220,
            height: 'auto',
            modal: true,
            dialogClass: 'confirm-popup',
            buttons: {
                Ok: function () {
                    $(this).dialog("close");
                },
                Cancel: function () {
                    $(this).dialog("close");
                }
            },
            close: function (event, ui) {
                $('#' + popupId).remove();
            }
        };

        let dialogOptions = $.extend( defaultOptions, options );
        popupHolder.find('#' + popupId).dialog(dialogOptions);
    }
}

// TODO: review this implementation with Ovi
const Dialog = new DialogMixin();

// One button should be an object with two keys, button text and callback

class ArchitectEditItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dialogConfig: {}
        };
    }

    render() {
        let body = null;
        if (this.props.isLocked) {
            body = (
                <div className={"architect-edit-item-module-inner " + (_.includes(['admin_edit', 'admin_create'], this.props.configurationScope) ? 'admin-scope' : 'owner-scope')}>
                    <p className="message warning">
                        {this.getLockedWarningMsg()}
                    </p>
                </div>
            );
        } else {
            body = (
                <div className={"architect-edit-item-module-inner " + (_.includes(['admin_edit', 'admin_create'], this.props.configurationScope) ? 'admin-scope' : 'owner-scope')}>
                    <ReactAddContentItemVersionNote ref='add_note' submit={this.save.bind(this)}/>
                    {this.renderHeader()}
                    {this.renderForm()}
                    {this.renderFooter()}
                    {this.state.loading && <div className="loading-mask"/>}
                </div>
            );
        }

        if(!_.includes(['admin_create', 'owner_create'], this.props.configurationScope)){
            window.location.hash = '#v=' + this.props.contentItemVersionId;
        }

        return body;
    }

    getLockedWarningMsg() {
        if(this.props.configurationScope === 'admin_edit'){
            return this.props.adminLockedWarningMsg.replace('{fullname}', this.props.recordLock.Person.fullname);
        } else {
            return this.props.ownerLockedWarningMsg;
        }
    }

    renderForm() {
        let fields = [];

        if(_.includes(['admin_edit', 'owner_edit'], this.props.configurationScope)) {
            fields.push(
                <FormFieldHidden key="content_item_id" name="ContentItem[id]" value={this.props.record['ContentItem']['id']} />
            );
        }

        this.props.fields.forEach(function (field, index) {
            let cls = (index % 2) !== 1 ? "odd" : "even";
            let value = this.props.record ? this.props.record['ArchitectItem'][field['alias']] : null;
            let originalValue = value;
            if(this.props.record && this.props.record['PreviousArchitectItem']){
                originalValue = this.props.record['PreviousArchitectItem'][field['alias']];
            }

            if (
                parseInt(this.props.module.settings.disable_permissive_max_length) != 1 &&
                field.settings &&
                parseInt(field.settings.permissiveMaxLength) == 1 &&
                parseInt(field.settings.maxLength) > 0 &&
                value && value.length > parseInt(field.settings.maxLength)
            ) {
                field.settings.maxLength = value.length;
            }

            let FieldClass = null;
            let fieldOptions = {
                ref: 'field_' + field['id'],
                key: 'field_' + field['id'],
                cls: cls,
                name: field['alias'],
                label: field['label'],
                required: field['is_required'],
                type: field.FieldType && field.FieldType.alias ? field.FieldType.alias : null,
                value: value,
                originalValue: originalValue,
                settings: field,
                disablePreviousButton: Boolean(parseInt(this.props.module.settings.disable_previous_values)),
            };

            if (field.FieldType.plugin === 'FieldTypes') {
                if (field.FieldType.alias === 'Text') {
                    FieldClass = FormFieldText;
                }
                if (field.FieldType.alias === 'TextArea') {
                    FieldClass = FormFieldTextArea;
                }
                if (field.FieldType.alias === 'TinyMCE' || field.FieldType.alias === 'HtmlEditor') {
                    FieldClass = FormFieldTinyMce;
                }
                if (field.FieldType.alias === 'Number' || field.FieldType.alias === 'Decimal') {
                    FieldClass = FormFieldNumber;
                }
                if (field.FieldType.alias === 'Checkbox') {
                    FieldClass = FormFieldCheckbox;
                }
                if (field.FieldType.alias === 'Date') {
                    FieldClass = FormFieldDate;
                }
                if (field.FieldType.alias === 'LinkSet') {
                    FieldClass = FormFieldLinkSet;
                }
            }
            if (field.FieldType.plugin === 'FileManager') {
                if (field.FieldType.alias === 'Image') {
                    FieldClass = FormFieldImage;
                    fieldOptions.maxUploadSize = this.props.maxUploadSize;
                    fieldOptions.uploadInstructions = field.instructions.length ? field.instructions : '';
                    fieldOptions.moduleItemId = this.props.module.id;
                    fieldOptions._moduleToken = this.props._moduleToken;
                    fieldOptions.fieldId = field.id;
                }
                if (field.FieldType.alias === 'ImageSet') {
                    FieldClass = FormFieldImage;
                    fieldOptions.maxUploadSize = this.props.maxUploadSize;
                    fieldOptions.uploadInstructions = field.instructions.length ? field.instructions : '';
                    fieldOptions.moduleItemId = this.props.module.id;
                    fieldOptions._moduleToken = this.props._moduleToken;
                    fieldOptions.fieldId = field.id;

                    if(!_.isPlainObject(fieldOptions.value)){
                        fieldOptions.value = {};
                    }
                    if(!_.isPlainObject(fieldOptions.originalValue)){
                        fieldOptions.originalValue = {};
                    }
                }
            }
            if (field.FieldType.plugin === 'Datagroups') {
                FieldClass = FormFieldDropdown;
                fieldOptions.url = SS.route('Datagroups', 'DatagroupValues', 'getAll');
                fieldOptions.urlParams = {limit: 500, datagroup_alias: field.FieldType.alias};
                fieldOptions.idPath = ['Datagroup' + field.FieldType.alias, 'id'];
                let displayField = field.settings && field.settings.displayField ? field.settings.displayField : 'name';
                fieldOptions.displayPath = ['Datagroup' + field.FieldType.alias, displayField];
                fieldOptions.urlParams.getFields = [fieldOptions.displayPath.join('.')];
                fieldOptions.hideDeletedValues = true;
            }
            if (field.FieldType.plugin === 'People') {
                if (field.FieldType.alias === 'Person') {
                    FieldClass = FormFieldPerson;
                }
            }

            if (FieldClass) {
                if (field.is_multi) {
                    fields.push(
                        <MultiFieldWrapper
                            key={'field_' + field['id']}
                            ref={'field_' + field['id']}
                            fieldCls={FieldClass}
                            options={fieldOptions}
                        />
                    )
                } else {
                    fields.push(
                        React.createElement(FieldClass, fieldOptions)
                    );
                }
            }

        }.bind(this));

        if(typeof this.props.module.settings.tag_category_ids !== 'undefined' && this.props.module.settings.tag_category_ids.length){
            this.props.module.settings.tag_category_ids.forEach((tagCategoryId, index) => {
                let label = _.get(_.find(this.props.tagCategories, ['TagCategory.id', tagCategoryId]), 'TagCategory.name', `Tag ${index}`);

                let value = null;
                if(this.props.record && this.props.record.TagAssignment){
                    value = _.filter(this.props.record.TagAssignment, ['Tag.category_id', tagCategoryId]);
                    value = _.join(_.map(value, 'tag_id'), ',');
                }

                let fieldOptions = {
                    ref: 'field_tag_' + tagCategoryId,
                    key: 'field_tag_' + tagCategoryId,
                    cls: 'odd',
                    name: 'tag',
                    label: label,
                    value: value,
                    originalValue: value,
                    url: SS.route('Tags', 'Tags', 'getAll'),
                    urlParams: {tag_category_ids: tagCategoryId},
                    idPath: ['Tag', 'id'],
                    displayPath: ['Tag', 'name'],
                    hideDeletedValues: true,
                    singleSelect: false,
                    disablePreviousButton: true,
                };

                fields.push(
                    React.createElement(FormFieldDropdown, fieldOptions)
                );
            });
        }

        if(typeof this.props.module.settings !== 'undefined' && this.props.module.settings.update_content_item === "1" && this.props.module.settings.allow_custom_alias === "1"){
            fields.push(React.createElement(FormFieldAlias, {
                ref: 'field_content_item_alias',
                key: 'field_content_item_alias',
                cls: 'odd',
                label: 'Alias',
                name: 'ContentItem[alias]',
                required: true,
                value: this.props.record['ContentItem']['alias'],
                originalValue: this.props.record['ContentItem']['alias'],
                previewUrl: 'https://' + this.props.domain + this.props.contentItemFullViewUrl,
                settings: {
                    settings: {
                        showCharacterCounter: false,
                        maxLength: 1000,
                    },
                },
            }));
        }

        if (this.props.campaignGiving && (!this.props.record || (this.props.record && this.props.record['ContributionCampaign']))) {
            fields.push(React.createElement(FormFieldCheckbox, {
                ref: 'field_contribution_campaign_is_disabled',
                key: 'field_contribution_campaign_is_disabled',
                cls: 'last',
                name: 'ContributionCampaign[is_disabled]',
                boxLabel: 'Check this to disable campaign giving',
                required: false,
                type: null,
                value: this.props.record ? this.props.record['ContributionCampaign']['is_disabled'] : false,
                originalValue: this.props.record ? this.props.record['ContributionCampaign']['is_disabled'] : false,
                settings: {
                    settings: {
                        hideLabel: true
                    }
                }
            }));
        }

        if (this.props.campaignGoalAmount && (!this.props.record || (this.props.record && this.props.record['ContributionCampaign']))) {
            fields.push(React.createElement(FormFieldNumber, {
                ref: 'field_contribution_campaign_goal_amount',
                key: 'field_contribution_campaign_goal_amount',
                cls: 'last',
                name: 'ContributionCampaign[goal_amount]',
                label: 'Campaign Goal Amount',
                required: false,
                type: null,
                value: this.props.record ? this.props.record['ContributionCampaign']['goal_amount'] : null,
                originalValue: this.props.record ? this.props.record['ContributionCampaign']['goal_amount'] : null,
            }));
        }

        if(typeof this.props.module.settings !== 'undefined' && this.props.module.settings.update_searchable === "1"){
            let boxLabel = 'Uncheck this to make the record unsearchable/unlisted';
            if(this.props.module.settings?.update_searchable_label){
                boxLabel = this.props.module.settings.update_searchable_label;
            }
            fields.push(React.createElement(FormFieldCheckbox, {
                ref: 'field_content_item_is_searchable',
                key: 'field_content_item_is_searchable',
                cls: 'last',
                name: 'ContentItem[is_searchable]',
                label: false,
                boxLabel: boxLabel,
                required: false,
                type: null,
                value: this.props.record ? this.props.record['ContentItem']['is_searchable'] : null,
                originalValue: this.props.record ? this.props.record['ContentItem']['is_searchable'] : null,
                settings: {
                    settings: {
                        hideLabel: true
                    }
                }
            }));

            if(this.props.module.settings?.update_searchable_disclaimer){
                fields.push(
                    <div dangerouslySetInnerHTML={{__html: this.props.module.settings?.update_searchable_disclaimer}}/>
                );
            }
        }

        if (this.props.campaignFixedAmounts && (!this.props.record || (this.props.record && this.props.record['ContributionCampaign']))) {
            fields.push(React.createElement(FormFieldFixedAmounts, {
                ref: 'field_contribution_campaign_fixed_amounts',
                key: 'field_contribution_campaign_fixed_amounts',
                cls: 'last',
                value: this.props.record && this.props.record['ContributionCampaignFixedAmount'] ? this.props.record['ContributionCampaignFixedAmount'] : [],
                inherited: this.props.record && this.props.record['InheritedContributionCampaignFixedAmount'] ? this.props.record['InheritedContributionCampaignFixedAmount'] : [],
            }));
        }

        return (
            <div className='section-content'>
                <div className="edit-form">
                    {fields}
                </div>
            </div>
        );
    }

    renderHeader() {
        if (this.props.configurationScope === 'admin_edit') {
            return (
                <div className="section-header">
                    <div className="left">
                        <div
                            className="title">{this.props.record.ArchitectItem.first_name} {this.props.record.ArchitectItem.last_name}</div>
                        {this.getCurrentStageBadge()}
                    </div>
                    <div className="right">
                        {this.getSaveToStageButton()}
                    </div>
                    <div className="clearfix"/>
                </div>
            );
        }
        if(this.props.configurationScope === 'owner_edit'){
            let style = {
                color: '#' + this.props.stageColor,
                background: this.props.stageBgColor,
            };
            return (<div className="section-header" style={style}>{this.props.currentStageMessage}</div>);
        }
        if(this.props.configurationScope === 'owner_create'){
            let style = {
                color: '#' + this.props.stageColor,
                background: this.props.stageBgColor,
            };
            return (<div className="section-header" style={style}>You are creating new content</div>);
        }
    }

    renderFooter() {
        if(this.props.configurationScope === 'admin_edit'){
            return (
                <div className="section-footer">
                    {this.props.allowPreview &&
                        <div className="left">
                            <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'preview', 'Edited by admin', 'auto')}>Preview Changes</button>
                        </div>
                    }
                    <div className="right">
                        {this.getCurrentStageBadge()}
                        {this.getSaveToStageButton(true)}
                    </div>
                    <div className="clearfix"/>
                </div>
            );
        }
        if(this.props.configurationScope === 'admin_create'){
            return (
                <div className="section-footer">
                    Not implemented
                    <div className="clearfix"/>
                </div>
            );
        }
        if(this.props.configurationScope === 'owner_edit'){
            return (
                <div className="section-footer">
                    {this.props.allowPreview &&
                        <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'preview', 'Edited by owner', 'auto')}>Preview</button>
                    }
                    {this.props.draftStage.id &&
                        <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'draft', 'Edited by owner', 'auto')}>Save Draft</button>
                    }
                    {this.props.saveStage.id &&
                        <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'save', 'Edited by owner', 'auto')}>Save & Publish</button>
                    }
                    {this.props.allowUnpublishing && this.props.unpublishStage.id &&
                        <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'deactivate', 'Edited by owner', false)}>Unpublish</button>
                    }
                    {Boolean(this.props.dashboard) &&
                        <button type="button" className="btn cancel" onClick={this.back.bind(this)}>Cancel</button>
                    }
                </div>
            );
        }
        if(this.props.configurationScope === 'owner_create'){
            return (
                <div className="section-footer">
                    {this.props.allowPreview &&
                        <button type="button" className="btn preview" onClick={this.userSave.bind(this, 'preview', 'Edited by owner', 'auto')}>Preview Profile</button>
                    }
                    {this.props.draftStage.id &&
                        <button type="button" className="btn draft" onClick={this.userSave.bind(this, 'draft', 'Edited by owner', 'auto')}>Save Draft</button>
                    }
                    {this.props.saveStage.id &&
                        <button type="button" className="btn save" onClick={this.userSave.bind(this, 'save', 'Edited by owner', 'auto')}>Save & Publish</button>
                    }
                    {this.props.allowUnpublishing && this.props.unpublishStage.id &&
                        <button type="button" className="btn cancel" onClick={this.userSave.bind(this, 'deactivate', 'Edited by owner', 'auto')}>{this.props.unpublishButtonText}</button>
                    }
                    {Boolean(this.props.dashboard) &&
                        <button type="button" className="btn" onClick={this.back.bind(this)}>Cancel</button>
                    }
                </div>
            );
        }
    }

    getSaveToStageButton(dropUp) {
        let stages = [];
        let currentStageIndex = false;
        let nextStageIndex = 0;
        let isCurrent = false;

        this.props.adminWorkflowStages.forEach(function (stage, index) {
            if (stage.id === this.props.record['WorkflowStage']['id']) {
                currentStageIndex = index;
                isCurrent = true;
            } else {
                isCurrent = false;
            }
            stages.push(
                <a
                    key={'stage' + (dropUp ? 'dropup' : 'dropdown') + stage['id']}
                    className={"dropdown-item " + (isCurrent ? 'active' : '')}
                    href="#"
                    onClick={this.adminSave.bind(this, stage, this.props.createNewVersion)}
                >{stage.name}</a>
            );
        }.bind(this));

        if (currentStageIndex !== false) {
            nextStageIndex = currentStageIndex + 1;
        } else {
            nextStageIndex = 0;
        }
        if (nextStageIndex === this.props.adminWorkflowStages.length) {
            nextStageIndex = 0;
        }

        return (
            <div key={dropUp ? 'dropup' : 'dropdown'} className="content-stage">
                <div className="move-to-stage">
                    <label className="stage-label">Save & Move to</label>
                    <div className={"btn-group move-to-button " + (dropUp ? 'dropup' : '')}>
                        <button type="button" className="btn"
                                onClick={this.adminSave.bind(this, this.props.adminWorkflowStages[nextStageIndex], this.props.createNewVersion)}>
                            {this.props.adminWorkflowStages[nextStageIndex]['name']}
                        </button>

                        <button type="button" className="btn dropdown-toggle" data-toggle="dropdown">
                            <span className="sr-only">Toggle Dropdown</span>
                        </button>
                        <div className="dropdown-menu dropdown-menu-right">
                            {stages}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    getCurrentStageBadge() {
        let style = {};
        if (this.props.record['WorkflowStage']['color'] != null && this.props.record['WorkflowStage']['color'].length) {
            style = {
                borderColor: '#' + this.props.record['WorkflowStage']['color'],
                color: '#' + this.props.record['WorkflowStage']['color'],
                background: 'transparent'
            };
        }

        return (
            <div className="current-stage">
                <label className="stage-label">Current Stage</label>
                <div className="current-stage-value form-control"
                     style={style}>{this.props.record['WorkflowStage']['name']}</div>
            </div>
        );
    }

    validateFields() {
        let validationErrors = [];

        this.props.fields.forEach(function (field) {
            if (this.refs['field_' + field['id']]) {
                let value = this.refs['field_' + field['id']].getValue();
                if (field.is_required && !value) {
                    validationErrors.push(field.label + ' is required');
                }
                if (field.settings && parseInt(field.settings.maxLength) > 0 && value && value.length > parseInt(field.settings.maxLength)) {
                    validationErrors.push(field.label + ' field length is limited to ' + field.settings.maxLength + ' characters');
                }
            }
        }.bind(this));

        if(typeof this.props.module.settings !== 'undefined' && this.props.module.settings.update_content_item === "1" && this.props.module.settings.allow_custom_alias === "1"){
            if (this.refs['field_content_item_alias']) {
                let value = this.refs['field_content_item_alias'].getValue();
                if (!value) {
                    validationErrors.push('Alias is required');
                }
            }
        }

        // untouched amounts aren't sent, so amounts an admin saved can't block the save
        if (this.refs['field_contribution_campaign_fixed_amounts'] && this.refs['field_contribution_campaign_fixed_amounts'].isDirty()) {
            validationErrors = validationErrors.concat(this.refs['field_contribution_campaign_fixed_amounts'].validate());
        }

        return validationErrors;
    }

    confirmUnpublish(stage, newVersion) {
        this._confirmedUnpublished = true;
        this.adminSave(stage, newVersion);
    }

    adminSave(stage, newVersion) {
        let validationErrors = this.validateFields();
        if (validationErrors.length > 0) {
            return Dialog.errorDialog('Validation Error', validationErrors.join('<br/>'));
        }

        if (newVersion === 'user' && this.props.record['WorkflowStage']['is_live'] && stage['is_unpublished'] && !this._confirmedUnpublished) {
            Dialog.confirmUnpublishDialog(
                this.props.unpublishDialogTitle,
                this.props.unpublishDialogText,
                this.confirmUnpublish.bind(this, stage, false),
                this.confirmUnpublish.bind(this, stage, true)
            );
            return;
        }

        this.refs.add_note.show(stage, null, newVersion);

        this._confirmedUnpublished = false;
    }

    userSave(stage, note, newVersion) {
        let validationErrors = this.validateFields();
        if (validationErrors.length > 0) {
            return Dialog.errorDialog('Validation Error', validationErrors.join('<br/>'));
        }

        if(this.props.unpublishConfirmation && stage === 'deactivate') {
            return Dialog.userUnpublishConfirmation('BY CLICKING THIS BUTTON', this.props.unpublishConfirmationBody, this.props.unpublishConfirmationButton, function(){
                this.save(stage, note, newVersion);
            }.bind(this));
        } else {
            this.save(stage, note, newVersion);
        }
    }

    back() {
        return Dialog.confirmDialog(null, 'Are you sure you want to leave this page?<br/>You will lose any unsaved information.', function(){
            window.location.href = this.props.dashboard;
        }.bind(this));
    }

    save(stage, note, newVersion) {
        let saveForPreview = (stage === 'preview' ? 1 : 0);
        let action = (typeof stage == 'string' ? stage : 'admin');
        if (this.props.createNewVersion == 'auto') {
            newVersion = 'auto';
        }
        if (newVersion != 'auto') {
            newVersion = (newVersion === true ? 1 : 0);
        }
        if (stage === 'preview') {
            stage = this.props.record['WorkflowStage'];
        }
        if (stage === 'draft') {
            stage = this.props.draftStage;
        }
        if (stage === 'save') {
            stage = this.props.saveStage;
        }
        if (stage === 'deactivate') {
            stage = this.props.unpublishStage;
            newVersion = 0;
        }

        let data = {
            '_action': action,
            '_createNewVersion': newVersion,
            '_moduleItemId': this.props.module.id,
            'module_item_id': this.props.module.id,
            '_moduleToken': this.props._moduleToken,
            'contentItemVersionId': this.props.contentItemVersionId,
            'ArchitectItem[id]': this.props.record ? this.props.record['ContentItemVersion']['id'] : null,
            'contentItemId': this.props.record ? this.props.record['ContentItem']['id'] : null,
            'contentTypeId': this.props.record ? this.props.record['ContentItem']['content_type_id'] : this.props.module.settings.content_type_id,
            'workflowStageId': stage.id,
            'commitMessage': note
        };

        this.props.fields.forEach(function (field) {
            if (this.refs['field_' + field['id']]) {
                data['ArchitectItem[' + field.alias + ']'] = this.refs['field_' + field['id']].getValue();
            }
        }.bind(this));

        if(typeof this.props.module.settings.tag_category_ids !== 'undefined' && this.props.module.settings.tag_category_ids.length){
            let tagIds = [];
            this.props.module.settings.tag_category_ids.forEach((tagCategoryId, index) => {
                if (this.refs['field_tag_' + tagCategoryId]) {
                    let value = this.refs['field_tag_' + tagCategoryId].getValue();
                    if(value && value.length){
                        tagIds = _.concat(tagIds, _.split(value, ','));
                    }
                }
            });
            data['TagAssignment[tag_ids]'] = tagIds;
        }


        if(this.props.campaignGiving && (!this.props.record || (this.props.record && this.props.record['ContributionCampaign']))){
            if (this.refs['field_contribution_campaign_is_disabled']) {
                let value = this.refs['field_contribution_campaign_is_disabled'].getValue();
                if (typeof value === 'boolean') {
                    value = value ? 1 : 0;
                }
                data['ContributionCampaign[is_disabled]'] = value;
            }
        }

        if(this.props.campaignGoalAmount && (!this.props.record || (this.props.record && this.props.record['ContributionCampaign']))){
            if (this.refs['field_contribution_campaign_goal_amount']) {
                data['ContributionCampaign[goal_amount]'] = this.refs['field_contribution_campaign_goal_amount'].getValue();
            }
        }

        if(typeof this.props.module.settings !== 'undefined' && this.props.module.settings.update_content_item === "1" && this.props.module.settings.allow_custom_alias === "1"){
            if (this.refs['field_content_item_alias']) {
                data['ContentItem[alias]'] = this.refs['field_content_item_alias'].getValue();
            }
        }

        if(typeof this.props.module.settings !== 'undefined' && this.props.module.settings.update_searchable === "1"){
            if (this.refs['field_content_item_is_searchable']) {
                let value = this.refs['field_content_item_is_searchable'].getValue();
                if (typeof value === 'boolean') {
                    value = value ? 1 : 0;
                }
                data['ContentItem[is_searchable]'] = value;
            }
        }

        // one JSON list, so an emptied list still reaches the server
        if (this.refs['field_contribution_campaign_fixed_amounts'] && this.refs['field_contribution_campaign_fixed_amounts'].isDirty()) {
            data['ContributionCampaignFixedAmounts'] = JSON.stringify(this.refs['field_contribution_campaign_fixed_amounts'].getValue());
        }

        this.setState({
            loading: true
        });

        $.ajax({
            url: SS.route('Architect', 'ArchitectModules', 'saveItem', null),
            method: 'post',
            data: data,
            dataType: 'json',
            cache: false,
            success: function (data) {
                this.setState({
                    loading: false
                });
                if (saveForPreview) {
                    Dialog.infoDialog(
                        'Preview',
                        'This will open a preview of your latest unsaved changes. You will still need to save your changes in order to preserve them.',
                        () => {
                            var previewUrl = '//' + this.props.domain + this.props.contentItemFullViewUrl + '?version=' + this.props.contentItemVersionId;
                            window.open(previewUrl, 'Preview');
                        }
                    );
                } else {
                    Dialog.infoDialog('Saved', 'Record successfully saved', () => data.redirectTo ? window.location.href = data.redirectTo : window.location.reload());
                }
            }.bind(this),
            error: function (xhr, status, err) {
                this.setState({
                    loading: false
                });
                // a rejected save explains why, e.g. a fixed amount the server didn't accept
                Dialog.errorDialog('Error', xhr.status === 400 ? _.get(xhr, 'responseJSON.message', 'An error Occurred') : 'An error Occurred');
            }.bind(this)
        });
    }
}

ArchitectEditItem.displayName = 'ArchitectEditItem';

ArchitectEditItem.defaultProps = {
    isLocked: false,
    recordLock: [],
    configurationScope: false,
    ownerLockedWarningMsg: 'This record is currently reviewed by an administrator. Please try again later.',
    adminLockedWarningMsg: 'This record is currently edited by {fullname}. Please try again later.',
    unpublishDialogTitle: 'Warning!',
    unpublishDialogText: 'You are about to unpublish Live content!<br/>Are you sure you want to proceed?',
    record: {},
    adminWorkflowStages: {},
    currentStageMessage: false,
    stageColor: '000',
    stageBgColor: 'fff',
    draftStage: false,
    saveStage: false,
    unpublishStage: false,
    allowPreview: false,
    allowUnpublishing: false,
    unpublishButtonText: 'Deactivate Profile',
    createNewVersion: 'auto',
    contentItemFullViewUrl: false,
    domain: SS.vars.FULL_BASE_URL,
    imageField: false,
    fields: {},
    maxUploadSize: 0,
    uploadInstructions: false,
    campaignGiving: false,
    campaignGoalAmount: false,
    campaignFixedAmounts: false,
    module: [],
    contentItemVersionId: null,
    tagCategories: [],
    dashboard: null,
    unpublishConfirmation: false,
    unpublishConfirmationButton: "Unpublish",
    unpublishConfirmationBody: "Are you sure you want to unpublish your public profile?",
};

class LabelWithOriginalValue extends React.Component {

    constructor(props) {
        super(props);
        this.triggerClickCounter = 0;
        this.state = {
            originalValue: this.props.originalValue,
            showOriginalValue: false
        };
    };

    onTriggerClick(event) {
        this.setState({
            showOriginalValue: !this.state.showOriginalValue
        });
        if (this.props.type === 'dropdown' && this.triggerClickCounter === 0) {
            this.setState({
                originalValue: this.props.getDropdown().getTextById(this.state.originalValue)
            });
        }
        this.triggerClickCounter++;
    };

    componentDidMount() {
        if (this.props.type === 'person' && this.triggerClickCounter === 0) {
            $.ajax({
                url: SS.route('People', 'People', 'getAll', null),
                method: 'get',
                data: {
                    id: this.state.originalValue,
                    simple: true,
                },
                dataType: 'json',
                cache: false,
                success: function (data) {
                    this.setState({
                        originalValue: data.records.length > 0 ? data.records[0]['Person']['fullname'] : "-",
                    });
                }.bind(this),
                error: function (xhr, status, err) {}.bind(this)
            });
        }
    }

    render() {

        let cls = 'label-with-original-value';
        let label = null;
        let originalValueTrigger = null;
        let originalValueBox = null;
        let characterCounter = null;

        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.value !== this.state.originalValue && !this.props.disablePreviousButton) {
            originalValueTrigger =
                <span className="label-changed-icon fa fa-pencil-square" onClick={this.onTriggerClick.bind(this)}/>;

            let originalValue = this.state.originalValue;
            if (!originalValue) {
                originalValue = '[empty]';
                if (this.props.type === 'number') {
                    originalValue = 'N/A';
                }
                if (this.props.type === 'checkbox') {
                    originalValue = false;
                }
            }
            if (typeof originalValue === 'string' && (this.props.type === 'tinymce' || this.props.type === 'textarea')) {
                originalValue = originalValue.replace(/(?:\r\n|\r|\n)/g, '<br/>');
            }
            if (typeof originalValue === 'string' && this.props.type === 'date') {
                let valDate = new Date(originalValue);
                originalValue = (valDate.getMonth() + 1) + "/" + valDate.getDate() + "/" + valDate.getFullYear();
            }
            if (typeof originalValue === 'boolean' && this.props.type === 'checkbox') {
                originalValue = originalValue ? 'Checked' : 'Unchecked';
            }
            if (typeof originalValue === 'string' && this.props.type === 'image') {
                let resizedPhoto = SS.com.FileManager.frontend.util.Resizer.getResizedPath(originalValue, 300, 300, null, true);
                originalValue = '<div class="content-image-holder"><img src="' + resizedPhoto + '" alt="Old Image" /></div>';
            }

            function createMarkup() {
                return {__html: originalValue}
            }

            originalValueBox = <div className="label-original-value" dangerouslySetInnerHTML={createMarkup()}/>
        }

        if (this.props.showCharacterCounter && (this.props.type === 'text' || this.props.type === 'tinymce' || this.props.type === 'textarea')) {
            let maxLength = parseInt(this.props.maxLength);

            let currentLength = 0;
            if (this.props.currentValue) {
                if (this.props.type === 'tinymce') {
                    currentLength = this.props.currentValue.replace(/(<([^>]+)>)/ig, "").trim();
                    currentLength = this.htmlDecode(currentLength);
                    currentLength = currentLength.length;
                } else {
                    currentLength = this.props.currentValue.length;
                }
            }

            let characterCounterStyle = {
                float: 'right',
                fontSize: '11px !important',
                color: (currentLength > maxLength ? 'red' : 'black'),
                backgroundColor: '#f0f0ee',
                border: 'solid 1px ' + (currentLength > maxLength ? 'red' : '#cccccc'),
                borderRadius: '3px',
                display: 'inline-block',
                padding: '0 4px',

            };
            characterCounter = (
                <div className="label-character-counter" style={characterCounterStyle}>
                    {currentLength}/{maxLength} chars
                </div>
            );
        }

        if (this.state.showOriginalValue) {
            cls += ' enabled';
        } else {
            cls += ' disabled';
        }

        return (
            <div className={cls}>
                {label}
                {originalValueTrigger}
                {characterCounter}
                {originalValueBox}
            </div>
        );
    };

    htmlDecode(value) {
        let txt = document.createElement("textarea");
        txt.innerHTML = value;
        return txt.value;
    };
}

LabelWithOriginalValue.displayName = 'LabelWithOriginalValue';

LabelWithOriginalValue.propTypes = {
    value: PropTypes.any,
    originalValue: PropTypes.any,
    currentValue: PropTypes.any,
    type: PropTypes.any,
    label: PropTypes.any,
    required: PropTypes.any,
    getDropdown: PropTypes.any,
    showCharacterCounter: PropTypes.bool,
    maxLength: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldHidden extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        }
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    }

    render() {
        return (
            <input type="hidden" value={this.props.value}/>
        );
    }
}

FormFieldHidden.displayName = 'FormFieldHidden';

FormFieldHidden.propTypes = {
    value: PropTypes.any
};

class FormFieldText extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    };

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    };

    render() {
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValueProps = {
            label: this.props.label,
            required: this.props.required,
            value: this.props.value,
            originalValue: this.props.originalValue,
            currentValue: this.state.value,
            type: 'text',
            showCharacterCounter: (parseInt(this.props.settings.settings.showCharacterCounter) === 1 && parseInt(this.props.settings.settings.maxLength) > 0),
            maxLength: this.props.settings.settings.maxLength,
            disablePreviousButton: this.props.disablePreviousButton,
        };

        let labelWithOriginalValue = (
            <LabelWithOriginalValue {...labelWithOriginalValueProps}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <input type="text" className={fieldCls} value={this.state.value || ''} onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    };
}

FormFieldText.displayName = 'FormFieldText';

FormFieldText.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldAlias extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
            copyButtonText: 'Copy URL',
        };
    };

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    };

    copyToClipboard(value) {
        if(navigator !== undefined){
            navigator.clipboard.writeText(value);
        }
        this.setState({
            copyButtonText: 'Copied',
        });
        setTimeout(function(){
            this.setState({
                copyButtonText: 'Copy URL',
            });
        }.bind(this), 2000);
    };

    render() {
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValueProps = {
            label: this.props.label,
            required: this.props.required,
            value: this.props.value,
            originalValue: this.props.originalValue,
            currentValue: this.state.value,
            type: 'text',
            showCharacterCounter: (parseInt(this.props.settings.settings.showCharacterCounter) === 1 && parseInt(this.props.settings.settings.maxLength) > 0),
            maxLength: this.props.settings.settings.maxLength
        };

        let labelWithOriginalValue = (
            <LabelWithOriginalValue {...labelWithOriginalValueProps}/>
        );

        let previewLink = this.props.previewUrl.split('/');
        previewLink.pop();
        previewLink.push(this.state.value);
        previewLink = previewLink.join('/');

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <input type="text" className={fieldCls} value={this.state.value || ''} onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="preview-url">
                        <div className={'text'}><label>Link:</label>{previewLink}</div>
                        <div className={'copy-button'} onClick={this.copyToClipboard.bind(this, previewLink)}>{this.state.copyButtonText}</div>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    };
}

FormFieldAlias.displayName = 'FormFieldAlias';

FormFieldAlias.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    previewUrl: PropTypes.string,
};

class FormFieldTextArea extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    };

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    };

    render() {

        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValueProps = {
            label: this.props.label,
            required: this.props.required,
            value: this.props.value,
            originalValue: this.props.originalValue,
            currentValue: this.state.value,
            type: 'textarea',
            showCharacterCounter: (parseInt(this.props.settings.settings.showCharacterCounter) === 1 && parseInt(this.props.settings.settings.maxLength) > 0),
            maxLength: this.props.settings.settings.maxLength,
            disablePreviousButton: this.props.disablePreviousButton,
        };

        let labelWithOriginalValue = (
            <LabelWithOriginalValue {...labelWithOriginalValueProps}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <textarea className={fieldCls} value={this.state.value || ''} onChange={this.onValueChange.bind(this)} rows={this.props.settings.settings.rows || 10}/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldTextArea.displayName = 'FormFieldTextArea';

FormFieldTextArea.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldTinyMce extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    componentDidMount() {
        let me = this;

        tinyMCE.init({
            selector: 'textarea[name="' + this.props.name + '"]',
            height: 200,
            theme: 'modern',
            plugins: ["link lists code table textcolor"],
            toolbar: "undo redo | styleselect | fontsizeselect | bold italic forecolor | bullist numlist outdent indent",
            menubar: false,
            statusbar: false,
            setup: function (editor) {
                editor.on('init', function () {
                    this.getDoc().body.style.fontSize = '14px';
                });
                editor.on('change', function (e) {
                    me.setState({value: editor.getContent()});
                });
                editor.on('keyup', function (e) {
                    me.setState({value: editor.getContent()});
                });
            }
        });
    };

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    };

    render() {

        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValueProps = {
            label: this.props.label,
            required: this.props.required,
            value: this.props.value,
            originalValue: this.props.originalValue,
            currentValue: this.state.value,
            type: 'tinymce',
            showCharacterCounter: (parseInt(this.props.settings.settings.showCharacterCounter) === 1 && parseInt(this.props.settings.settings.maxLength) > 0),
            maxLength: this.props.settings.settings.maxLength,
            disablePreviousButton: this.props.disablePreviousButton,
        };

        let labelWithOriginalValue = (
            <LabelWithOriginalValue {...labelWithOriginalValueProps}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <textarea name={this.props.name} ref="mainInput" className={fieldCls} value={this.state.value || ''}
                                  onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldTinyMce.displayName = 'FormFieldTinyMce';

FormFieldTinyMce.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

FormFieldTinyMce.displayName = 'FormFieldTinyMce';

class FormFieldNumber extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    };

    onValueChange(event) {
        this.setState({value: event.target.value});
    };

    getValue() {
        return this.state.value;
    };

    render() {

        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={this.props.value} originalValue={this.props.originalValue} type="number" disablePreviousButton={this.props.disablePreviousButton}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <input type="number" className={fieldCls} value={this.state.value}
                               onChange={this.onValueChange.bind(this)}/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldNumber.displayName = 'FormFieldNumber';

FormFieldNumber.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldFixedAmounts extends React.Component {

    constructor(props) {
        super(props);
        this.nextKey = 0;
        this.defaultFieldName = _.uniqueId('fixed_amount_default_');
        this.state = {
            fixedAmounts: _.map(this.props.value, fixedAmount => this.createFixedAmount(fixedAmount))
        };
        this.initialValue = JSON.stringify(this.getValue());
        this.initialLabels = _.fromPairs(_.map(this.state.fixedAmounts, fixedAmount => [fixedAmount.id, _.trim(fixedAmount.label)]));
    };

    /**
     * The amounts are only sent when they were changed, so a save doesn't undo changes made elsewhere meanwhile
     */
    isDirty() {
        return JSON.stringify(this.getValue()) !== this.initialValue;
    };

    createFixedAmount(fixedAmount) {
        return {
            key: this.nextKey++,
            id: fixedAmount.id || null,
            amount: fixedAmount.amount || '',
            label: fixedAmount.label || '',
            is_default: _.includes([true, 1, '1'], fixedAmount.is_default),
        };
    };

    addFixedAmount() {
        this.setState(state => ({
            // the first amount is the default one, the way the server keeps it
            fixedAmounts: state.fixedAmounts.concat(this.createFixedAmount({is_default: !state.fixedAmounts.length}))
        }));
    };

    removeFixedAmount(key) {
        this.setState(state => {
            let fixedAmounts = _.reject(state.fixedAmounts, ['key', key]);
            // one of the remaining amounts takes over as the default
            if (fixedAmounts.length && !_.some(fixedAmounts, 'is_default')) {
                fixedAmounts = fixedAmounts.map((fixedAmount, index) => index ? fixedAmount : {...fixedAmount, is_default: true});
            }
            return {fixedAmounts};
        });
    };

    onFieldChange(key, field, event) {
        let value = event.target.value;
        this.setState(state => ({
            fixedAmounts: state.fixedAmounts.map(fixedAmount => fixedAmount.key === key ? {...fixedAmount, [field]: value} : fixedAmount)
        }));
    };

    onDefaultChange(key) {
        this.setState(state => ({
            fixedAmounts: state.fixedAmounts.map(fixedAmount => ({...fixedAmount, is_default: fixedAmount.key === key}))
        }));
    };

    getValue() {
        return this.state.fixedAmounts.map(fixedAmount => ({
            id: fixedAmount.id,
            amount: _.trim(fixedAmount.amount),
            label: _.trim(fixedAmount.label),
            is_default: fixedAmount.is_default,
        }));
    };

    /**
     * The same checks the server makes when saving
     */
    validate() {
        let errors = [];
        let amounts = [];

        this.getValue().forEach((fixedAmount, index) => {
            let name = 'Fixed amount ' + (index + 1);

            // the column is a decimal(10,2)
            if (!/^\d{1,8}(\.\d{1,2})?$/.test(fixedAmount.amount) || parseFloat(fixedAmount.amount) <= 0) {
                errors.push(name + ' needs an amount greater than 0, with at most 2 decimals');
            } else {
                // the giving form tells the amounts apart by their value
                let amount = parseFloat(fixedAmount.amount).toFixed(2);
                if (_.includes(amounts, amount)) {
                    errors.push(name + ': the amount ' + amount + ' is already listed');
                }
                amounts.push(amount);
            }

            if (!fixedAmount.label) {
                errors.push(name + ' needs a label');
            } else if (fixedAmount.label.length > 100) {
                errors.push(name + ': the label can have at most 100 characters');
            } else if (/[<>]/.test(fixedAmount.label) && this.initialLabels[fixedAmount.id] !== fixedAmount.label) {
                // labels are printed as they are; one an admin already saved is kept as it is
                errors.push(name + ': the label cannot contain < or >');
            }
        });

        return errors;
    };

    render() {

        let cls = 'field-group form-input-wrapper field-group-fixed-amounts';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    <LabelWithOriginalValue label={this.props.label} disablePreviousButton={true}/>
                    <div className="field-holder form-input-holder edit-field">
                        <table className="fixed-amounts">
                            {Boolean(this.state.fixedAmounts.length) &&
                            <thead>
                            <tr>
                                <th className="fixed-amount-amount">Amount</th>
                                <th className="fixed-amount-label">Label</th>
                                <th className="fixed-amount-default">Default</th>
                                <th className="fixed-amount-remove"/>
                            </tr>
                            </thead>
                            }
                            <tbody>
                            {this.state.fixedAmounts.map(fixedAmount => (
                                <tr key={fixedAmount.key}>
                                    <td className="fixed-amount-amount">
                                        <input type="number" className="field" min="0.01" step="0.01" value={fixedAmount.amount}
                                               onChange={this.onFieldChange.bind(this, fixedAmount.key, 'amount')}/>
                                    </td>
                                    <td className="fixed-amount-label">
                                        <input type="text" className="field" maxLength={100} value={fixedAmount.label}
                                               onChange={this.onFieldChange.bind(this, fixedAmount.key, 'label')}/>
                                    </td>
                                    <td className="fixed-amount-default">
                                        <input type="radio" name={this.defaultFieldName} checked={fixedAmount.is_default}
                                               onChange={this.onDefaultChange.bind(this, fixedAmount.key)}/>
                                    </td>
                                    <td className="fixed-amount-remove">
                                        <button type="button" className="fixed-amount-remove-button" title="Remove this amount"
                                                onClick={this.removeFixedAmount.bind(this, fixedAmount.key)}>
                                            <span className="fa fa-times"/>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {!this.state.fixedAmounts.length &&
                            <tr>
                                <td className="fixed-amounts-empty" colSpan={4}>
                                    <div className="fixed-amounts-empty-text">
                                        {this.props.inherited.length ?
                                            'This campaign has no amounts of its own, so donors see the folder or category ones: ' +
                                            this.props.inherited.map(fixedAmount => fixedAmount.amount + ' (' + fixedAmount.label + ')').join(', ') +
                                            '. Adding amounts here replaces them.' :
                                            'No fixed amounts defined for your campaign'
                                        }
                                    </div>
                                    <button type="button" className="btn btn-primary btn-sm fixed-amounts-add" onClick={this.addFixedAmount.bind(this)}>
                                        <span className="fa fa-plus"/> Add your first fixed amount
                                    </button>
                                </td>
                            </tr>
                            }
                            </tbody>
                        </table>
                        {Boolean(this.state.fixedAmounts.length) &&
                        <button type="button" className="btn btn-primary btn-sm fixed-amounts-add" onClick={this.addFixedAmount.bind(this)}>
                            <span className="fa fa-plus"/> Add Amount
                        </button>
                        }
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldFixedAmounts.displayName = 'FormFieldFixedAmounts';

FormFieldFixedAmounts.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    value: PropTypes.array,
    // what the giving form shows while the campaign has no amounts of its own
    inherited: PropTypes.array,
};

FormFieldFixedAmounts.defaultProps = {
    label: 'Fixed Amounts',
    value: [],
    inherited: [],
};

class FormFieldCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    onValueChange(event) {
        this.setState({value: event.target.checked});
    };

    getValue() {
        return this.state.value;
    };

    render() {
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={this.props.value} originalValue={this.props.originalValue} type="checkbox" disablePreviousButton={this.props.disablePreviousButton}/>
        );

        let field = React.createElement('input', {
            type: 'checkbox',
            defaultChecked: !!this.state.value,
            className: fieldCls,
            onClick: this.onValueChange.bind(this)
        });

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {parseInt(this.props.settings.settings.hideLabel) !== 1 && labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <label className="c-input c-checkbox">
                            {field}
                            <span className="c-indicator"/>
                            <span
                                className="c-label">{this.props.settings.settings.boxLabel || this.props.boxLabel}</span>
                        </label>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldCheckbox.displayName = 'FormFieldCheckbox';

FormFieldCheckbox.propTypes = {
    label: PropTypes.string,
    boxLabel: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldDate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: moment(this.props.value, "YYYY-MM-DD")
        };
    }

    componentDidMount() {
        let me = this;
        let mainInput = $(ReactDOM.findDOMNode(this.refs.mainInput));
        mainInput.datepicker({
            changeMonth: true,
            changeYear: true,
            yearRange: "c-100:c+100",
            altFormat: "yyyy-mm-dd",
            onSelect: function (date) {
                let value = moment(this.value, "MM-DD-YYYY");
                if(!value.isValid()){
                    value = '';
                }
                me.setState({value: value});
            }
        });
        if (this.state.value) {
            mainInput.datepicker('setDate', this.state.value.isValid() ? this.state.value.toDate() : "");
        }
    };

    // onValueChange(event) {
    //     this.setState({value: event.target.value});
    // };

    getValue() {
        return this.state.value.isValid() ? this.state.value.format("YYYY-MM-DD") : "";
    };

    render() {

        let cls = 'field-group form-input-wrapper datepicker-holder';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field datepicker jquery-ui-datepicker';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        // let val = this.state.value;

        // if (val) {
        //     let valDate = new Date(val);
        //     val = (valDate.getMonth() + 1) + "/" + valDate.getDate() + "/" + valDate.getFullYear();
        // }

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={this.props.value} originalValue={this.props.originalValue} type="date" disablePreviousButton={this.props.disablePreviousButton}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <input ref="mainInput" type="text" className={fieldCls}/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldDate.displayName = 'FormFieldDate';

FormFieldDate.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldCombo extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
        };
    }

    getValue() {
        return this.state.value;
    };

    onSelectChange(event) {
        this.setState({
            value: event.target.value
        });
    };

    render() {

        let cls = 'field-group field-group-combo form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';

        let label = null;
        if (this.props.label) {
            label =
                <label className={this.props.required ? 'required' : undefined} htmlFor="">{this.props.label}</label>;
        }

        if (this.props.cls)
            cls += ' ' + this.props.cls;

        let options = [];

        if (this.props.empty) {
            options.push(
                <option value="">{this.props.empty}</option>
            );
        }

        let getOptions = this.props.options;

        if (getOptions) {
            Object.keys(getOptions).map(function (key) {
                options.push(
                    <option key={key} value={key}>{getOptions[key]}</option>
                );
            });
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {label}
                    <div className={fieldHolderCls}>
                        <select onChange={this.onSelectChange.bind(this)} value={this.state.value}>
                            {options}
                        </select>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldCombo.displayName = 'FormFieldCombo';

FormFieldCombo.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.object,
    empty: PropTypes.string
};

class FormFieldDropdown extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
        };
    };

    getValue() {
        return this.state.value;
    };

    getDisplayValue() {
        return this.state.displayValue;
    };

    clearValue() {
        return this.refs.dropdown_field.clearValue();
    };

    onDropdownValueChange() {
        let valueParam = {
            value: this.refs.dropdown_field.getValue().length ? this.refs.dropdown_field.getValue() : null,
            displayValue: this.refs.dropdown_field.getValue().length ? this.refs.dropdown_field.getText() : null,
        };
        this.setState(valueParam);
        if (this.props.onChange) {
            this.props.onChange(valueParam)
        }
    };

    render() {
        let props = this.props;
        let state = this.state;
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let dropDown = (
            <ReactFieldDropdown
                ref="dropdown_field"
                disabled={props.disabled}
                placeholder={props.placeholder}
                name={props.name}
                idPath={props.idPath}
                displayPath={props.displayPath}
                records={props.records}
                url={props.url}
                urlParams={props.urlParams}
                singleSelect={props.singleSelect}
                value={props.value || ''}
                onChange={this.onDropdownValueChange.bind(this)}
                hideDeletedValues={props.hideDeletedValues}
            />
        );

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={this.props.value} originalValue={this.props.originalValue} type="dropdown" disablePreviousButton={this.props.disablePreviousButton} getDropdown={function () {
                return this.refs.dropdown_field
            }.bind(this)}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        {dropDown}
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldDropdown.displayName = 'FormFieldDropdown';

FormFieldDropdown.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    placeholder: PropTypes.string,
    name: PropTypes.string, // the name of the hidden input
    idPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    displayPath: PropTypes.arrayOf(PropTypes.string).isRequired,
    records: PropTypes.arrayOf(PropTypes.object), // either this or 'url'
    url: PropTypes.string, // either this or 'records'
    urlParams: PropTypes.object, // you should set {limit: 10} or something small to avoid performance issues
    singleSelect: PropTypes.bool,
    search: PropTypes.bool, // set to true to show a search icon instead of a dropdown
    disabled: PropTypes.bool,
    onChange: PropTypes.func, // called exactly the same as here http://semantic-ui.com/modules/dropdown.html#additional-settings
    hideDeletedValues: PropTypes.bool,
    disablePreviousButton: PropTypes.bool,
};

class FormFieldLinkSet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            url: this.props.value.url,
            target: this.props.value.target,
            text: this.props.value.text,
        };
    };

    getValue() {
        return {
            is_custom_link: "0",
            target: this.state.target,
            text: this.state.text,
            url: this.state.url,
        };
    };

    onTextValueChange(event) {
        this.setState({
            text: event.target.value
        });
    }

    onUrlValueChange(event) {
        this.setState({
            url: event.target.value
        });
    }

    onTargetValueChange(event) {
        this.setState({
            target: event.target.value
        });
    }

    onDropdownValueChange() {
        // let valueParam = {
        //     value: this.refs.dropdown_field.getValue().length ? this.refs.dropdown_field.getValue() : null,
        //     displayValue: this.refs.dropdown_field.getValue().length ? this.refs.dropdown_field.getText() : null,
        // };
        // this.setState(valueParam);
        // if (this.props.onChange) {
        //     this.props.onChange(valueParam)
        // }
    };

    render() {
        let props = this.props;
        let state = this.state;
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field flexed';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        let labelWithOriginalValueProps = {
            label: this.props.label,
            required: this.props.required,
            value: `${this.props.value.text || ""} | ${this.props.value.url || ""} | ${this.props.value.target || ""}`,
            originalValue: `${this.props.originalValue.text || ""} | ${this.props.originalValue.url || ""} | ${this.props.originalValue.target || ""}`,
            currentValue: `${this.state.text || ""} | ${this.state.url || ""} | ${this.state.target || ""}`,
            type: 'text',
            showCharacterCounter: false,
            maxLength: null,
            disablePreviousButton: this.props.disablePreviousButton,
        };

        let labelWithOriginalValue = (
            <LabelWithOriginalValue {...labelWithOriginalValueProps}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <input type="text" name={`${this.props.name}[text]`} className={'field text'} value={this.state.text} placeholder={'Button Text'} onChange={this.onTextValueChange.bind(this)}/>
                        <input type="text" name={`${this.props.name}[url]`} className={'field url'} value={this.state.url} placeholder={'Button URL'} onChange={this.onUrlValueChange.bind(this)}/>
                        <select className={'field target'} name={`${this.props.name}[target]`} onChange={this.onTargetValueChange.bind(this)}>
                            <option value="_self" selected={this.state.target === '_self' ? 'selected' : ''}>Self</option>
                            <option value="_blank" selected={this.state.target === '_blank' ? 'selected' : ''}>Blank</option>
                        </select>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldLinkSet.displayName = 'FormFieldLinkSet';

FormFieldLinkSet.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    name: PropTypes.string, // the name of the hidden input
};

class MultiFieldWrapper extends React.Component {

    constructor(props) {
        super(props);
        let fieldCollection = {};
        let originalFieldCollection = {};
        let valuesData = this.props.options.value ? this.props.options.value : [];
        let originalValuesData = this.props.options.originalValue ? this.props.options.originalValue : [];
        let index = 0;

        if (valuesData.length) {
            valuesData.forEach(function (value) {
                fieldCollection[index++] = value
            })
        } else {
            fieldCollection = {
                0: null
            }
        }

        index = 0;
        if (originalValuesData.length) {
            originalValuesData.forEach(function (value) {
                originalFieldCollection[index++] = value
            })
        } else {
            originalFieldCollection = {
                0: null
            }
        }

        this.state = {
            fieldCls: this.props.fieldCls,
            options: this.props.options,
            fieldCollection: fieldCollection,
            originalFieldCollection: originalFieldCollection,
            fieldIndex: index
        };
    };

    addField() {
        let state = this.state;
        let fieldIndex = state.fieldIndex;
        fieldIndex++;
        let fieldCollection = state.fieldCollection;
        fieldCollection[fieldIndex] = null;
        let originalFieldCollection = state.originalFieldCollection;
        originalFieldCollection[fieldIndex] = null;

        this.setState({
            fieldIndex: fieldIndex,
            fieldCollection: fieldCollection,
            originalFieldCollection: originalFieldCollection
        })
    };

    removeField(index) {
        let state = this.state;
        let fieldCollection = state.fieldCollection;
        let originalFieldCollection = state.originalFieldCollection;
        let fieldIndex = state.fieldIndex;
        delete fieldCollection[index];
        delete originalFieldCollection[index];

        if (parseInt(Object.keys(fieldCollection).length) === 0) {
            fieldIndex = state.fieldIndex;
            fieldIndex++;
            fieldCollection[fieldIndex] = null;
        }
        if (parseInt(Object.keys(originalFieldCollection).length) === 0) {
            fieldIndex = state.fieldIndex;
            fieldIndex++;
            originalFieldCollection[fieldIndex] = null;
        }

        this.setState({
            fieldCollection: fieldCollection,
            originalFieldCollection: originalFieldCollection,
            fieldIndex: fieldIndex
        })

    };

    getValue() {
        let fieldCollection = this.state.fieldCollection;
        let keys = Object.keys(fieldCollection);
        let values = [];
        let val = '';
        keys.forEach(function (key) {
            val = this.refs['field_' + key].getValue();
            if (val || val == 0) {
                values.push(val);
            }

        }.bind(this));
        if (values.length) {
            return values;
        } else {
            return '';
        }

    };

    render() {
        let props = this.props;
        let state = this.state;
        let fieldCollection = state.fieldCollection;
        let originalFieldCollection = state.originalFieldCollection;
        let singleFieldOptions = state.options;

        let fields = [];
        let fieldKeys = Object.keys(fieldCollection);

        fieldKeys.forEach(function (key) {
            let value = fieldCollection[key];
            let originalValue = originalFieldCollection[key];
            let name = state.options.name + '[' + key + ']';
            singleFieldOptions.key = 'field_' + key;
            singleFieldOptions.ref = 'field_' + key;

            singleFieldOptions.value = value;
            singleFieldOptions.originalValue = originalValue;
            singleFieldOptions.name = name;


            fields.push(
                <div className="multi-field " key={"multi-field" + key}>
                    <div className="field-wrapper">
                        {React.createElement(state.fieldCls, singleFieldOptions)}
                    </div>
                    <div className="field-controls">
                        <div className="field-add fa fa-plus" onClick={this.addField.bind(this)}/>
                        <div/>
                        <div className="field-remove fa fa-times" onClick={this.removeField.bind(this, key)}/>
                    </div>
                </div>
            )
        }.bind(this));

        return (
            <div className={'multi-fields ' + (parseInt(fieldKeys.length) === 1 ? 'single-field' : '')}>
                {fields}
                <div className="clearfix"/>
            </div>
        );
    }
}

MultiFieldWrapper.displayName = 'MultiFieldWrapper';

MultiFieldWrapper.propTypes = {
    fieldCls: PropTypes.any,
    options: PropTypes.any
};

class FormFieldImage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isImageSet: props.settings.FieldType.alias === 'ImageSet',
            value: props.value
        };
    };

    onValueChange(event) {
        let value = event.target.value;
        if(this.state.isImageSet){
            value = _.clone(this.state.value);
            _.set(value, 'url', event.target.value);
        }
        this.setState({value: value});
    };

    getValue() {
        return this.state.value;
    };

    registerListeners() {
        let holder = $(ReactDOM.findDOMNode(this.refs.image_holder)); // where.find('.person-photo-holder');

        $(document).bind('drop dragover', function (e) {
            e.preventDefault();
        });
        let me = this;

        // Upload image
        holder.find('.image-upload-holder .add-image-upload').fileupload({
            url: SS.route('Architect', 'ArchitectModules', 'imageUploadHandler', null),
            formData: {
                'data[_Token][key]': SS.csrfToken,
                'module_item_id': this.props.moduleItemId,
                '_moduleToken': this.props._moduleToken,
                'fieldId': this.props.fieldId
            },
            dataType: 'json',
            dropZone: holder.find('.image-upload-holder'),
            pasteZone: holder.find('.image-upload-holder'),
            // Enable image resizing, except for Android and Opera
            disableImageResize: /Android(?!.*Chrome)|Opera/
                .test(window.navigator.userAgent),
            previewCrop: true, // preview width is set in uploadHandler
            error: function (jqXHR, textStatus, errorThrown) {
                let responseObject = jqXHR.responseText ? JSON.parse(jqXHR.responseText) : null;
                let errorMessage = responseObject && responseObject.name ? responseObject.name : errorThrown;
                holder.find('.image-upload-holder').append('<div class="upload-error">' + errorMessage + '</div>').find('.upload-error').delay(6000).fadeOut(300)
            }.bind(this),
            add: function (e, data) {
                data.context = $('<p/>').text('Uploading...');
                holder.find(".content-image-progress").append(data.context);
                data.submit();
            }
        }).on('fileuploadprogressall', function (e, data) {
            let progress = parseInt(data.loaded / data.total * 100, 10);
            holder.find('.content-image-progress .bar').show().css('width', progress + '%');
        }).on('fileuploaddone', function (e, data) {

            data.context.text('Upload finished.').delay(2000).fadeOut(300);
            holder.find('.content-image-progress .bar').delay(2000).fadeOut(300);

            let objMessage = data.result;
            if (objMessage.image) {
                let response = objMessage.image[0];
                if (response.error) {
                    holder.find('.image-upload-holder').append('<div class="upload-error">' + response.error + '</div>').find('.upload-error').delay(6000).fadeOut(300);
                } else {
                    let newValue = response.url;
                    if(this.state.isImageSet){
                        newValue = _.clone(this.state.value);
                        _.set(newValue, 'url', response.url);
                    }
                    me.setState({
                        value: newValue,
                    });
                }
            }
        }.bind(this)).on('fileuploadfail', function (e, data) {
            $.each(data.files, function (index, file) {
                data.context.append(file.error).delay(3000).fadeOut(300);
            });
        });

        holder.find('.image-upload-holder.with-image button.remove-image').unbind().bind('click', function (e) {
            e.preventDefault();
            let newValue = null;
            if (this.state.isImageSet) {
                newValue = _.clone(this.state.value);
                _.set(newValue, 'url', null);
            }
            me.setState({
                value: newValue
            })
        }.bind(this));
    };

    componentDidMount() {
        this.registerListeners();
    };

    componentDidUpdate() {
        this.registerListeners();
    };

    render() {
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let holderCls = "image-upload-holder";
        let photo = this.state.photo ? this.state.photo : null;
        let photoEl = "";

        let isImageSet = this.state.isImageSet;
        let value = this.state.value ? (isImageSet ? this.state.value.url : this.state.value) : null;
        let originalValue = this.props.originalValue ? (isImageSet ? this.props.originalValue.url : this.props.originalValue) : null;
        if (value) {
            holderCls += " with-image";

            let resizedPhoto = SS.com.FileManager.frontend.util.Resizer.getResizedPath(value, 300, 300, null, true);

            photoEl = (
                <div className="db-image">
                    <img src={resizedPhoto} alt={this.props.label}/>
                    <button className="remove-image">Remove Image</button>
                </div>
            );
        }

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={value} originalValue={originalValue} type="image" disablePreviousButton={this.props.disablePreviousButton}/>
        );

        let uploadInstructions = null;
        if (this.props.uploadInstructions.length > 0) {
            uploadInstructions = (
                <span>
                    <b>Note:</b> {this.props.uploadInstructions}<br/><br/>
                </span>
            );
        }

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        <div className="content-image-holder" ref="image_holder">
                            <form action="" type="file" method="post" noValidate="novalidate">
                                <div className="content-image-progress">
                                    <div className="bar"/>
                                </div>
                                <div className={holderCls}>
                                    {photoEl}
                                    <div className="inner">
                                        <i className="icon"/>
                                        <span className="upload-button-holder">
                                    <button className="add-image">Add Image</button>
                                    <input className="add-image-upload" type="file" name="image"/>
                                </span>
                                    </div>
                                    <div className="uploaded-image-holder"/>
                                </div>
                            </form>
                        </div>
                        <div className="upload-instructions">
                            {uploadInstructions}
                            <b>Upload limitations:</b><br/>
                            Valid files: JPG, PNG<br/>
                            {this.props.maxUploadSize && 'Maximum allowed file size: ' + Math.round(parseInt(this.props.maxUploadSize) / 1024 / 1024) + 'MB'}
                        </div>
                        <div className="clearfix"/>
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldImage.displayName = 'FormFieldImage';

FormFieldImage.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    maxUploadSize: PropTypes.any,
    uploadInstructions: PropTypes.any
};

FormFieldImage.defaultProps = {
    isLocked: false,
    recordLock: [],
    configurationScope: false,
    ownerLockedWarningMsg: 'This record is currently reviewed by an administrator. Please try again later.',
    adminLockedWarningMsg: 'This record is currently edited by {fullname}. Please try again later.',
    unpublishDialogTitle: 'Warning!',
    unpublishDialogText: 'You are about to unpublish Live content!<br/>Are you sure you want to proceed?',
    record: {},
    adminWorkflowStages: {},
    currentStageMessage: false,
    stageColor: '000',
    stageBgColor: 'fff',
    draftStage: false,
    saveStage: false,
    unpublishStage: false,
    allowPreview: false,
    allowUnpublishing: false,
    createNewVersion: 'auto',
    contentItemFullViewUrl: false,
    domain: SS.vars.FULL_BASE_URL,
    imageField: false,
    fields: {},
    maxUploadSize: 0,
    uploadInstructions: false,
    campaignGiving: false,
    module: [],
    contentItemVersionId: null,
};

class FormFieldPerson extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.props.value,
        };
    };

    getValue() {
        return this.state.value;
    };

    getDisplayValue() {
        return this.state.displayValue;
    };

    clearValue() {
        return this.refs.person_field.clearValue();
    };

    onDropdownValueChange() {
        let valueParam = {
            value: this.refs.person_field.getValue().length ? this.refs.person_field.getValue() : null,
        };
        this.setState(valueParam);
        if (this.props.onChange) {
            this.props.onChange(valueParam.value)
        }
    };

    render() {
        let props = this.props;
        let state = this.state;
        let cls = 'field-group form-input-wrapper';
        let fieldHolderCls = 'field-holder form-input-holder edit-field';
        let fieldCls = 'field';

        if (this.props.cls) {
            cls += ' ' + this.props.cls;
        }

        if (this.props.type) {
            cls += ' field-group-' + this.props.type;
        }

        let dropDown = (
            <ReactFieldDropdown
                ref="person_field"
                disabled={props.disabled}
                placeholder={props.placeholder}
                name={props.name}
                idPath={['Person', 'id']}
                displayPath={['Person', 'fullname']}
                url={SS.route('People', 'People', 'getAll', null)}
                urlParams={{limit: 10, simple: 1, type: 'person', current_id: props.value}}
                search={true}
                singleSelect={props.singleSelect}
                value={props.value || ''}
                onChange={this.onDropdownValueChange.bind(this)}
            />
        );

        let labelWithOriginalValue = (
            <LabelWithOriginalValue label={this.props.label} required={this.props.required} value={this.props.value} originalValue={this.props.originalValue} type="person" disablePreviousButton={this.props.disablePreviousButton} getDropdown={function () {
                return this.refs.person_field
            }.bind(this)}/>
        );

        return (
            <div className={cls}>
                <div className="field-group-inner">
                    {labelWithOriginalValue}
                    <div className={fieldHolderCls}>
                        {dropDown}
                    </div>
                    <div className="clearfix"/>
                </div>
            </div>
        );
    }
}

FormFieldPerson.displayName = 'FormFieldPerson';

FormFieldPerson.propTypes = {
    label: PropTypes.string,
    cls: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.any,
    originalValue: PropTypes.any,
    placeholder: PropTypes.string,
    name: PropTypes.string, // the name of the hidden input
    singleSelect: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func, // called exactly the same as here http://semantic-ui.com/modules/dropdown.html#additional-settings
    disablePreviousButton: PropTypes.bool,
};